import { AutoCompleteModel } from '../../core/component/autocomplete/autocomplete-model';
import { ModelBase } from '../../core/model/model-base';

export class HomeqCompanyOptions {
  constructor(data: any) {
    this.companies = data.map(val => new AutoCompleteModel(val.name, val.id));
  }

  companies: AutoCompleteModel[];
}

export class HQCompanyModel extends ModelBase {
  constructor(data: any) {
    super();
    this.id = data.id;
    this.name = data.name;
  }

  id: string;
  name: string;
}

export class HQPropertyCompanyModel {
  constructor(data: any) {
    this.propertyId = data.propertyId;
    this.companyId = data.companyId;
  }

  propertyId: string;
  companyId: number;
}

export class HomeqDefaultsModel {
  constructor(data: any) {
    this.companies = data.companies.map(val => new AutoCompleteModel(val.name, val.id));
    this.propertiesCompanies = data.propertiesCompanies;
  }

  companies: AutoCompleteModel[];
  propertiesCompanies: HQPropertyCompanyModel[];
}

export interface MultipleSendToHomeQ {
  dwellingIds: string[];
  propertiesCompanies: HQPropertyCompanyModel[];
}
